<script lang="ts">
    import NauiInput from "../../../../naui/atoms/NauiInput.svelte";
    import NauiSelect from "../../../../naui/atoms/NauiSelect.svelte";
    import Question from "./Question.svelte";
    import NauiButton from "../../../../naui/atoms/NauiButton.svelte";

    let edadOptions = [
        {
            'label': 'Entre 20 y 40',
            'value': '20-40'
        },
        {
            'label': 'Entre 40 y 60',
            'value': '40-60'
        }
    ]

    let questions = [
        '1. Facilidad en el acceso a la Compañía para reportar su Siniestro',
        '2. ¿Existió claridad desde el primer momento sobre el proceso que debía seguir?',
        '3. Disponibilidad y amabilidad del taler designado por la Compañía para la reparación de su vehículo',
        '4. Tiempo transcurrido para generar la orden de reparación por parte de la Compañía',
        '5. Su experiencia (en términos de oportunidad y calidad) durante su proceso de reparación de su vehículo en el taller'
    ]

    let recomendariaQ='6. Siendo 0 - Totalmente no los recomendaría y 10 - Totalmente los recomendaría, ¿Usted recomendaría los productos y servicios ofrecidos por HDI a algún conocido o familiar?';


</script>
<div>
    <div class="grid-3 gap-1 mb-25">
        <NauiInput label="nombre"/>
        <NauiSelect label="Edad" options="{edadOptions}"/>
        <NauiInput label="Profesion"/>
    </div>
    <div class="mb-15">
        <strong>Indique por favor de 1.a 5, siendo 1 - Totalmente Insatisfecho y 5 - Totalmente Satisfecho, el nivel de
            satisfacción con cada una de las actividades mencionadas</strong>
    </div>
    {#each questions as q, i}
        <Question question="{q}" id="{'question'+i}"/>
    {/each}
    <Question question="{recomendariaQ}" id="question-6" bold="{true}" scale="10" low="Totalmente NO los recomendaría" high="Totalmente SI los recomendaría" />
    <p class="mb-ii">En el siguiente espacio usted podrá consignar los comentarios que estime relevantes, los cuales nos servirán para mantener buenas prácticas o continuar mejorando el nivel de servicio al cliente</p>
    <textarea class="naui-input w-100"></textarea>
    <div class="my-2">
        <strong>Agradecemos su tiempo. No olvide visitar nuestro sitio web <a href="https://hdi.com.co" target="_blank" class="accent">www.HDI.com.co</a> y mantenerse informado de los productos y servicios que ofrecemos para asegurar su tranquilidad.</strong>
    </div>
    <div class="mt-2">
        <div class="box-l sx-1">
        <NauiButton caption="Regresar" mode="outline" color="accent" className="min-w-200px"  />
        <NauiButton caption="Enviar Encuesta" mode="solid" color="accent" className="min-w-200px"/>
    </div>
    </div>


</div>